import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Button.module.scss';

export const ButtonLabel = ({ className = '', children = [] }) => (
  <span className={clsx(styles.buttonLabel, className)}>{children}</span>
);

ButtonLabel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
